import React from "react";
import { Box } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import YeniDosyaTuruBildirim from "../components/YeniDosyaTuruBildirim";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  const data = JSON.parse(localStorage.getItem("user"));
  return (
    <Box display="flex" height="100vh">
      <Sidebar />

      <Box flex={1} display="flex" flexDirection="column">
        {data.id === 0 && <Topbar username={data.ad} />}
        {data.type === "kurum" && <Topbar username={data.ad} />}
        {data.type === "personel" && <Topbar username={data.ad + " " + data.soyad} />}

        <Box flex={1} bgcolor="#F9FAFB" p={3} overflow="auto">
          <Outlet />
        </Box>

        {/* Kurum girişlerinde yeni dosya türü bildirimi */}
        <YeniDosyaTuruBildirim />
      </Box>
    </Box>
  );
};

export default MainLayout;
